export default __webpack_public_path__ + "img/fb7b9cc8592ea93d5e68625b0120912c.png";